/** Visible product states. Technical conditions never add another main state. */
export const HAUPTSTATUS_WORT = {
  in_arbeit: 'In Arbeit',
  fuer_dich_vorbereitet: 'Für dich vorbereitet',
  von_dir_zurueckgestellt: 'Von dir zurückgestellt',
  abgeschlossen: 'Abgeschlossen',
} as const;
export type Hauptstatus = keyof typeof HAUPTSTATUS_WORT;
export interface GuideHauptstatus {
  hauptstatus: Hauptstatus;
  hauptstatus_text: string;
  arbeitsinformation: string;
}
